import type { SetStateAction } from "react";
import useDraft from "@/shared/hooks/useDraft";
import { CHAT_DRAFT, type ChatDraft } from "../drafts";

/** A chat's draft (`chatDraftKey`) with a setter per part, each taking a value or an updater as
    `useState`'s does. `handed`: words the chat opens with in place of anything kept (Builder's
    New agent draft). */
export default function useChatDraft(key: string, handed?: string) {
  const { draft, set, take, settle, carry } = useDraft(key, CHAT_DRAFT, handed ? { ...CHAT_DRAFT.empty, text: handed } : undefined);
  const part = <K extends keyof ChatDraft>(name: K) => (update: SetStateAction<ChatDraft[K]>) =>
    set((now) => ({ ...now, [name]: typeof update === "function" ? (update as (value: ChatDraft[K]) => ChatDraft[K])(now[name]) : update }));
  return {
    ...draft,
    setText: part("text"),
    setMentions: part("mentions"),
    setQuote: part("quote"),
    setFiles: part("files"),
    take,
    settle,
    carry,
  };
}
